const config = {
    baseUrl: "https://api.winkdoc.com",
    socketUrl: "wss:api.winkdoc.com"
};
export const ImageBaseURL = "/winkdoc-api/rest/uploads/"
export default config;
